














































































































































































































































































































































































































































import { Component, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import GenericEdit from "../../core/Generics/GenericEdit";
import Porposal from "@/models/porposal/porposal.model";
import { ProjectState } from "@/enums/projectState";
import PorposalService from "@/services/porposal.service";
import GantCharttComponent from "@/components/ganttChart/gantChartt.vue";

@Component({
  components: {
    GantCharttComponent,
  },
})
export default class PorposalDetailToPrint extends GenericEdit<Porposal> {
  loading: boolean = true;
  finishedState: ProjectState = ProjectState.Finished;
  inHoldState: ProjectState = ProjectState.InHold;
  proposalService: PorposalService = new PorposalService();

  isLoadingGeneralDescriptionFirstPart: boolean = true;
  isLoadingGeneralDescriptionSecondPart: boolean = true;
  isLoadingLiteraryRevision: boolean = true;
  isLoadingMethodology: boolean = true;
  isLoadingInstitutionalEnviroment: boolean = true;
  isLoadingGanttDiagram: boolean = true;
  isLoadingObjectives: boolean = true;

  constructor() {
    super();
    this.controller = "Porposal/GetProposalOptimized";
    this.model = new Porposal();
  }

  created() {
    if (this.$route.params.id) {
      let id = Number(this.$route.params.id);
      this.repository.byId(id).then((response: Porposal) => {
        if (response.startDate)
          response.startDate = new Date(response.startDate);
        if (response.endDate) response.endDate = new Date(response.endDate);
        this.model = response;

        // cargar detalle (detalle)

        this.proposalService
          .getProposalDetailGeneralDescriptionFirstPartById(id)
          .then((data: Porposal) => {
            this.model.executiveSummary = data.executiveSummary;
            this.model.abstract = data.abstract;
            this.model.introduction = data.introduction;
            this.isLoadingGeneralDescriptionFirstPart = false;
          });

        this.proposalService
          .getProposalDetailGeneralDescriptionSecondPartById(id)
          .then((data: Porposal) => {
            this.model.researchProblem = data.researchProblem;
            this.model.objetives = data.objetives;
            this.model.justification = data.justification;
            this.isLoadingGeneralDescriptionSecondPart = false;
          });

        this.proposalService
          .getProposalDetailLiteraryRevisionById(id)
          .then((data: Porposal) => {
            this.model.background = data.background;
            this.model.stateOfTheArt = data.stateOfTheArt;
            this.isLoadingLiteraryRevision = false;
          });

        this.proposalService
          .getProposalDetailMethodologyById(id)
          .then((data: Porposal) => {
            this.model.researchQuestions = data.researchQuestions;
            this.model.hypothesis = data.hypothesis;
            this.model.methodsAndMaterials = data.methodsAndMaterials;
            this.isLoadingMethodology = false;
          });

        this.proposalService
          .getProposalDetailInstitutionalEnviromentById(id)
          .then((data: Porposal) => {
            this.model.institutionDescription = data.institutionDescription;
            this.model.personalInvolveProposal = data.personalInvolveProposal;
            this.model.otherActors = data.otherActors;
            this.isLoadingInstitutionalEnviroment = false;
          });

        this.proposalService
          .getProposalConsotiumsById(id)
          .then((data: Porposal) => {
            this.model.proposedConsortiums = data.proposedConsortiums;
          });

        this.proposalService
          .getProposalArticulatedInvestigadorById(id)
          .then((data: Porposal) => {
            this.model.proposalArticulatedInvestigador =
              data.proposalArticulatedInvestigador;
          });

        this.proposalService
          .getProposalUsersReportsById(id)
          .then((data: Porposal) => {
            this.model.porposalUsersReports = data.porposalUsersReports;
          });

        this.proposalService
          .getProporsalUsersEvaluatorsById(id)
          .then((data: Porposal) => {
            this.model.proporsalUsersEvaluators = data.proporsalUsersEvaluators;
          });

        this.proposalService
          .getProposalAnaliticalMatrixById(id)
          .then((data: Porposal) => {
            this.model.especificObjectives = data.especificObjectives;
            this.isLoadingObjectives = false;
          });

        // cargar ganttDiagram (cronograma)
        this.proposalService
          .getProposalGanttDiagramById(id)
          .then((data: Porposal) => {
            this.model.proposalScheduleGanttPhases =
              data.proposalScheduleGanttPhases;
            this.model.proposalHistoricPercentDoneScheduleGantts =
              data.proposalHistoricPercentDoneScheduleGantts;

            if (
              this.model.proposalHistoricPercentDoneScheduleGantts.length > 0
            ) {
              let lastGanttHistory = this.model
                .proposalHistoricPercentDoneScheduleGantts[
                this.model.proposalHistoricPercentDoneScheduleGantts.length - 1
              ];

              if (lastGanttHistory) {
                for (
                  let i = 0;
                  i < this.model.proposalScheduleGanttPhases.length;
                  i++
                ) {
                  const phase = lastGanttHistory.proposalHistoricPhasesPercentDone.find(
                    (x) =>
                      x.proposalScheduleGanttPhaseId ==
                      this.model.proposalScheduleGanttPhases[i].id
                  );
                  if (phase) {
                    this.model.proposalScheduleGanttPhases[i].percentDone =
                      phase.percentDone;
                    this.model.proposalScheduleGanttPhases[i].percentDoneUI =
                      phase.percentDone;
                  }
                  for (
                    let j = 0;
                    j <
                    this.model.proposalScheduleGanttPhases[i]
                      .proposalScheduleGanttActivities.length;
                    j++
                  ) {
                    const activity = phase.proposalHistoricActivitiesPercentDone.find(
                      (x) =>
                        x.proposalScheduleGanttActivityId ==
                        this.model.proposalScheduleGanttPhases[i]
                          .proposalScheduleGanttActivities[j].id
                    );
                    if (activity) {
                      this.model.proposalScheduleGanttPhases[
                        i
                      ].proposalScheduleGanttActivities[j].percentDone =
                        activity.percentDone;
                      this.model.proposalScheduleGanttPhases[
                        i
                      ].proposalScheduleGanttActivities[j].percentDoneUI =
                        activity.percentDone;
                    }
                  }
                }
              }
            }
            this.isLoadingGanttDiagram = false;
          });

        this.loading = false;
      });
    }
  }

  get isloadingDetailTab() {
    return (
      this.isLoadingGeneralDescriptionFirstPart ||
      this.isLoadingGeneralDescriptionSecondPart ||
      this.isLoadingLiteraryRevision ||
      this.isLoadingMethodology ||
      this.isLoadingInstitutionalEnviroment ||
      this.isLoadingGanttDiagram ||
      this.isLoadingObjectives
    );
  }

  printPdf() {
    window.print();
  }
}
